(function() {
    "use strict";

    if (document.querySelector("#standard-gallery-splide")) {
        const galleryStrip = document.querySelector("#standard-gallery");
        
        // Initilise the Gallery
        const standardGallery = new Splide('#standard-gallery-splide', {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            pagination: false,
            arrows: false,
            autoplay: true,
            interval: 2200,
            focus: "center",
            gap: "6rem",
            updateOnMove: true,
            breakpoints: {
                600: {
                    perPage: 1,
                    gap: 0
                }
            }
        }); 
        standardGallery.mount();


        // Trigger the next/prev slides
        galleryStrip.querySelector("[data-splide-next]").addEventListener("click", () => standardGallery.go('+${i}'));
        galleryStrip.querySelector("[data-splide-prev]").addEventListener("click", () => standardGallery.go('-${i}'));
    }
 
})();